import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';


const Demographic_1 = () => {
      const userID = sessionStorage.getItem("UserID");
      const currentDate1 = new Date();
      const toast = useRef(null);
      
      const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
      const dt = useRef(null);
      const [loading, setLoading] = useState(false);
  
      const [data, setData] = useState([]);
      const getDemographicRawData = async () => {
        try {
          setLoading(true);

          const requestData = {
            logged_in_userid: userID,
   	        table_name:"trn_tbl_patient_registration",
            synceddatetime: formattedCurrentDate,
            FormCode: "202",
            ApiKey: "kavin",
            AppTypeNo: "3",
            AppVersion: "1.0.0",
            data_source: "W"
          };
    
        const result = await api.get_Raw_Data(requestData);
        const responseData = result.trn_tbl_patient_registration;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
               }));
               setData(slNo);
        } catch (error) {
          console.error("Error fetching state:", error);
          toast.current.show({
            severity: "info",
            summary: "No Data Found",
            detail: "There is no data for this table"
          });
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        getDemographicRawData();
      }, []);

      const cleanValue = (value) => {
        if (value === "-999" || value === -999) return "";

        if (typeof value === "string" && value.includes("$")) {
          return value.split("$").join(",");
        }

        return value;
      };


    const exportData = data.map(item => ({
        "SlNo": item.slno,
        "Sate" : cleanValue(item.fld_state_name),
        "District" : cleanValue(item.fld_district_name),
        "Site" : cleanValue(item.fld_site_name),
        "Taluk" : cleanValue(item.fld_taluk_name),
        "Village" : cleanValue(item.fld_village_name),
        "PHC" : cleanValue(item.fld_phc_name),
        "PHC Type" : cleanValue(item.fld_phc_type_name),
        "PRS name" : cleanValue(item.fld_prs_name),
        "Participant registration date" : cleanValue(item.fld_participant_registration_date),
        "Participant Name" : cleanValue(item.fld_participant_name),
        "Participant ID" : cleanValue(item.fld_participant_id),
        "Age": cleanValue(item.fld_age),
        "Gender": cleanValue(item.fld_gender_name),
        "Caste": cleanValue(item.fld_caste_name),
        "Religion": cleanValue(item.fld_religion_name),
        "Phone": cleanValue(item.fld_phone_number),
        "House Number":cleanValue(item.fld_house_number),
        "Street Name":cleanValue(item.fld_street_name),
        "Participent Taluk":cleanValue(item.fld_participant_taluk),
        "Participent Village":cleanValue(item.fld_participant_village),
        "Pin Code":cleanValue(item.fld_pin_code),
        "Marital status":cleanValue(item.fld_marital_status_name),
        "Work status":cleanValue(item.fld_work_status_name),
        "Education Name":cleanValue(item.fld_education_name),
        "Job description":cleanValue(item.fld_job_description),
        "Presence co-morbidities name":cleanValue(item.fld_presence_co_morbidities_name),
        "Specify co-morbidities name":cleanValue(item.fld_specify_co_morbidities_name),
        "Do you want to give consent to participate in the study?":cleanValue(item.fld_is_consent_name),
        "Loggedin User ID": cleanValue(item.fld_loggedin_user_id),
        "System Inserted Date": item.fld_system_inserted_datetime
          ? new Date(item.fld_system_inserted_datetime).toISOString().split("T")[0]
          : "", // fallback in case value is missing
    }));

      const handleDownloadCSV = () => {
          if (!data || data.length === 0) {
            console.warn("No data available to export");
            return;
          }

          // Convert JSON to worksheet
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, `Demographic_details_data`);

          // Generate buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "csv",
            type: "array"
          });

          // Create Blob and trigger download
          const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
          saveAs(dataBlob, "Demographic_details_data.csv");
        };


  return (
    <div>
        <Toast ref={toast} position="top-right" />
      
        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
        <span className='flex justify-content-end mt-2 mb-4'>
            <Button className="downloadbutton"
                label='Download CSV'
                icon="pi pi-download"
                onClick={handleDownloadCSV}
            />
        </span>
            <DataTable
              value={data}
              scrollHeight="350px"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              ref={dt}
              scrollable
            >
              <Column field="slno" header="Sl.No" />
              <Column field="fld_phc_name" header="PHC Name" />
              <Column field="fld_loggedin_user_id" header="User ID" />
              <Column field="fld_participant_name" header="Participent Name"></Column>
              <Column field="fld_participant_id" header="Participent ID"></Column>
              <Column field="fld_age" header="Age"></Column>
              <Column field="fld_phone_number" header="Phone Number"></Column>
              <Column field="fld_gender_name" header="Gender"></Column>
              <Column field="fld_caste_name" header="Caste"></Column>
            </DataTable>
    </div>
  )
}

export default Demographic_1